import React from 'react';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';

const QuoteParagraph = ({ paragraph }: ParagraphProps) => (
  <blockquote className="paragraph quote-paragraph">
    <i className="icon icon-quote" />

    <div
      // eslint-disable-next-line
      dangerouslySetInnerHTML={{ __html: paragraph.data.html }}
    />

    {paragraph.data.quotee ? <footer>— {paragraph.data.quotee}</footer> : null}
  </blockquote>
);

export default QuoteParagraph;
